export { default } from './SliderIcon'
